import React from "react";

const QuerySummary = (props) => {
    const maxItemInPage=props.numberItems * props.currentPage;
    const placeholders = [
        props.numberItems * (props.currentPage-1)+1,
        maxItemInPage > props.totalItems ? props.totalItems : maxItemInPage, 
        props.totalItems];
    const dynamicText = window.finderTable.dict.querySummary.replace(/\{\d+\}/g, (match) => placeholders[match.replace(/\{|\}/g, '')]);

    return (
        <div className="finderTable-query-summary">
            <div>{dynamicText}</div>
        </div>
    );
}

export default QuerySummary;